import * as React from "react";
import "./ErrorForceRefresh.scss";
import QuiqButton from "./QuiqButton";

interface ErrorForceRefreshProps {
  errorMessage?: string;
  status?: string;
}

const refreshPage = () => window.location.reload();

export const ErrorForceRefresh: React.SFC<ErrorForceRefreshProps> = ({
  errorMessage,
  status
}) => (
  <div className="ErrorForceRefresh__container">
    <i className="material-icons ErrorForceRefresh__error-icon">error</i>
    <div className="ErrorForceRefresh__message">{errorMessage}</div>
    {status !== "deleted" && status !== "rejected" && (
      <>
        <div className="ErrorForceRefresh__message--subtext">
          Please close or refresh the page to continue.
        </div>

        <QuiqButton
          className="ErrorForceRefresh__button--refresh"
          onClick={refreshPage}
          color="blue"
        >
          Refresh
        </QuiqButton>
      </>
    )}
  </div>
);

ErrorForceRefresh.defaultProps = {
  errorMessage: "Something went wrong."
};



// WEBPACK FOOTER //
// ./src/shared/ErrorForceRefresh.tsx